import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { AutomationStep } from "@/types/Automation";
import type { StepNodeData } from "../types";

export function MailerLiteCreateSubscriberFields({
  step,
  onMailerLiteGroupIdsChange,
}: {
  step: AutomationStep;
  onMailerLiteGroupIdsChange: StepNodeData["onMailerLiteGroupIdsChange"];
}) {
  const groupIds = step.data?.groupIds ?? [];

  return (
    <div className="p-4 space-y-3 nodrag" onPointerDownCapture={(e) => e.stopPropagation()}>
      <div className="space-y-2">
        <Label className="text-xs text-green-800">Group IDs (optional)</Label>
        <p className="text-xs text-muted-foreground">MailerLite group ids as plain text (one per row).</p>
        <div className="space-y-2">
          {groupIds.map((gid, gi) => (
            <div key={gi} className="flex gap-2">
              <Input
                value={gid}
                onChange={(e) => {
                  const next = [...groupIds];
                  next[gi] = e.target.value;
                  onMailerLiteGroupIdsChange({ stepId: step.id, groupIds: next });
                }}
                placeholder="Group ID"
                className="text-sm"
              />
              <Button
                type="button"
                variant="ghost"
                size="icon"
                className="shrink-0 h-8 w-8"
                onClick={() => {
                  const next = groupIds.filter((_, i) => i !== gi);
                  onMailerLiteGroupIdsChange({ stepId: step.id, groupIds: next });
                }}
              >
                <Trash2 className="h-3 w-3" />
              </Button>
            </div>
          ))}
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="w-full text-sm"
            onClick={() =>
              onMailerLiteGroupIdsChange({
                stepId: step.id,
                groupIds: [...groupIds, ""],
              })
            }
          >
            <Plus className="h-4 w-4 mr-1" />
            Add group
          </Button>
        </div>
      </div>
    </div>
  );
}
